import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chapters"
export default class extends Controller {
  connect() {
  }

  deleteChapter(event) {
    event.preventDefault()
    var item = event.currentTarget

    var ans = confirm("Are you sure you want to delete this chapter?")
    if(ans) {
      $.ajax({
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        url: item.href,
        type: "DELETE",
        success: function(e) {
          if(e.status == 200){
            document.getElementById(item.dataset.id).remove()
          } else {
            alert("Chapter could not be deleted")
          }
        }
      });
    }
  }
}
